require('./style.scss');

export const accessibilityTemplate = function (onCallback, translateService) {
    const modalClass = 'modal_accessibility'
    const wrapper = document.createElement('div');
    wrapper.classList.add(modalClass);

    const heading = document.createElement('p');
    heading.classList.add(`${modalClass}--heading`);
    heading.textContent = translateService.translate(`ACCESIBILITY_OPTIONS`);

    const title = document.createElement('div');
    title.classList.add(`${modalClass}--title`);
    title.innerHTML = `<span>${translateService.translate(`ACCESIBILITY_TITLE`)} <a href="mailto:support@eyespy360.com">support@eyespy360.com</a></span>`;

    const container = document.createElement('div');
    container.classList.add(`${modalClass}--container`);

    const types = [
        {title: translateService.translate('ACCESIBILITY_HOTSPOT'), type: 'hotspot', template: 'button'},
        {title: translateService.translate('ACCESIBILITY_DESATURATE'), type: 'desaturate', template: 'button'},
        {title: translateService.translate('ACCESIBILITY_AUTOROTATE_ON'), type: 'autorotate_on', template: 'button'},
        {title: translateService.translate('ACCESIBILITY_ENLARGE_CURSOR'), type: 'enlarge_cursor', template: 'button'},
        {title: translateService.translate('ACCESIBILITY_BIGGER_TEXT'), type: 'bigger_text', steps: 3, template: 'slider'},
    ]

    types.forEach(({title, type, steps, template}) => {
        container.appendChild(createButton({modalClass, title, steps, template, onCallback, type}));
    })

    wrapper.appendChild(heading);
    wrapper.appendChild(title);
    wrapper.appendChild(document.createElement('br'));
    wrapper.appendChild(container);

    return wrapper;
}

function createButton({title, type, steps, template, onCallback, modalClass}) {
    const block = document.createElement('div');
    const button = document.createElement('span');
    button.textContent = title;
    block.classList.add(`${modalClass}--${type}`);
    block.onclick = onCallback.bind(null, type);
    block.appendChild(button);

    if(steps){
        const div = document.createElement('div');
        div.classList.add('steps-wrapper');

        for(let i = 0; i < steps; i++){
            const row = document.createElement('div');
            row.classList.add('steps');

            div.appendChild(row);
        }

        block.appendChild(div);
    }

    return block;
}

